import { Box } from "@mui/material";
import { Gantt } from "../../../misc/Gantt";
import { useTaskFeed } from "../../../misc/Feed";
import { panelFontSize } from "./PanelSection";
import { Crumb } from "./TaskCrumbs";

// TaskGantt lays out the chain of work this task sits in: the tasks it waits on, the
// tasks waiting on it, and everything those reach in turn.
export function TaskGantt(props: {
    taskId: number;
    onOpen: (crumb: Crumb) => void;
}) {
    // the chart reads through the feed, so a dependency added in the tab beside it
    // redraws the chain without a reload
    const linked = useTaskFeed({ linkedTo: props.taskId });

    return (
        <Box sx={{ pt: 1 }}>
            {linked.LoadingOrErrorElement}
            <Gantt
                tasks={linked.tasks}
                emptyText="No related tasks"
                unplaced="place"
                selectedId={props.taskId}
                fontSize={panelFontSize}
                onSelect={task => {
                    // the panel is already on this task, so only the rest of the chain
                    // is somewhere to walk to
                    if (task.id === props.taskId) return;

                    props.onOpen({ id: task.id, title: task.title });
                }}
            />
        </Box>
    );
}
